/**
 *    @author: Andrew Sheen
 *    @since:  2020-10-30
 */

import { Component, OnInit,ElementRef,Input,Output, EventEmitter,AfterViewInit} from '@angular/core';
import { ControlBaseComponent } from "../control-base.component";
import { DeviceDetectorService } from 'ngx-device-detector';
import { TimerService } from 'src/refresh/service/timer-service';

@Component({
  selector: 'ng-select',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.less']
})
export class DropdownComponent extends ControlBaseComponent implements OnInit,AfterViewInit {

        private static id_no:number = 1;  
        public  ctrId:string;
        private selectCtrl:any;

        public get inputClass():string {
               return "ontario-dropdown " + this.input_class;
        }

        public get labelClass():string {
               return "input-label " + this.label_class;
        }

        public get className():string {
             return this.class_name;
        }

     
        constructor(private elRef:ElementRef, private device: DeviceDetectorService,protected timerService:TimerService) { 
                    super(timerService,2);
                    this.class_name = "control-margin ";
        }

       @Input ('ng-model')  set input( value: any) {

                this._inputX = value;

                if ( this._inputX === undefined ) this.inputX = "";
                else                            
                if ( typeof this._inputX == 'number' ) {
                     if ( this._inputX ) this.inputX = this._inputX.toString();
                     else                this.inputX = "";
                }
                else this.inputX = this._inputX;
         }

         get input() {
             return this._inputX;
         }


      
       @Input('item-list') itemList: Object;
       @Input() size: number;
      
       @Input() placeholder: string;
      
       @Output('focus')   focusChange   = new EventEmitter<string>();
       @Output('blur')    blurChange    = new EventEmitter<string>();
     //@Output('change')  : works

       public inputX:string = "";

       public ngOnInit(): void {

              this.textClass = "option-grey"

              this.selectCtrl = this.elRef.nativeElement.querySelector('select');
              let inline     = this.selectCtrl.parentElement.parentElement.getAttribute("inline");
               
              if ( inline != null  && inline !==  'false' ) {
                   if ( this.label_class )  this.label_class += " inline";
                   else                     this.label_class = "inline";

                   this.labelStyle = "margin-right:0.4em";
                   this.class_name = "";
              }

              if ( this.size ) {
                  if ( this.size >= 18 && this.device.isMobile() ) {
                          this.selectCtrl.style.minWidth = "100%";
                          this.selectCtrl.style.width = "100%";
                  }
                  else {
                        this.selectCtrl.style.minWidth = this.size + "em"; 
                        this.selectCtrl.style.width = this.size + "em"; 
                  }
                        
             }    
  
              if ( !this.id ) { 
                    this.id = "dd_"+ DropdownComponent.id_no++;
              }

              this.ctrId = "select_"+this.id;

              super.errorParamSet();
       }

       public ngAfterViewInit()  {

           let parent = this.selectCtrl.parentElement;

           super.layoutFromViewInit(parent);  
       }  
  
       public onFocus() {
              this.focusChange.emit(this.input);
       }

       public onBlur() {
              this.blurChange.emit(this.input);  
       }            

       public inputModelChange(value) {

             this.inputX = value;
             
             if ( typeof this._inputX == 'number' ) {
                  if ( value )
                       this._inputX = Number(value);
                  else this._inputX = 0;
             }
             else this._inputX = value;
       }
}
